var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.125rem",
    height: "1.1875rem",
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66749 18.5875L17.9175 2.08754C17.9822 1.95821 18.0081 1.81295 17.9921 1.66924C17.9761 1.52554 17.919 1.38951 17.8275 1.27754C17.7379 1.1706 17.6202 1.09079 17.4877 1.04707C17.3552 1.00334 17.2132 0.997446 17.0775 1.03004L9 3.25003L0.944996 1.00003C0.831703 0.969455 0.712818 0.965885 0.597895 0.989613C0.482973 1.01334 0.375221 1.0637 0.283304 1.13665C0.191387 1.2096 0.117872 1.3031 0.0686683 1.40963C0.0194626 1.51617 -0.00405887 1.63276 -3.84861e-06 1.75003C0.000699958 1.86744 0.0289573 1.98304 0.0824966 2.08753L8.33249 18.5875C8.39543 18.7104 8.49105 18.8135 8.60883 18.8855C8.7266 18.9575 8.86196 18.9956 8.99999 18.9956C9.13803 18.9956 9.27339 18.9575 9.39116 18.8855C9.50893 18.8135 9.60456 18.7104 9.66749 18.5875ZM2.1675 2.91253L8.25 4.57004L8.24999 11.5L9.74999 11.5L9.75 4.57004L15.8325 2.91254L8.99999 16.57L2.1675 2.91253Z",
    fill: "#8977A0"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentIcon);
export default __webpack_public_path__ + "static/media/sentIcon.b9db51dd729f1a3e9f577538b6017829.svg";
export { ForwardRef as ReactComponent };